/* FLORSS CRM TRACKING */
(function () {
  'use strict';

  if (window.__florssCrmTrackingLoaded) return;
  window.__florssCrmTrackingLoaded = true;

  // Prevents the old PDP-only add-to-cart tracker from sending duplicate events.
  window.__florssAddToCartTrackingLoaded = true;
  document.documentElement.setAttribute('data-florss-crm-tracking', 'ready');

  var ENDPOINT = 'https://n8n.florss.com.br/webhook/florss/crm-bi/site-events-v2';
  var STORAGE_PREFIX = 'florss_crm_';
  var SESSION_TTL = 30 * 60 * 1000;
  var sentKeys = {};
  var scrollDepths = [25, 50, 75, 90];
  var sentScrollDepths = {};
  var cachedCart = null;
  var cartPromise = null;
  var pendingAddToCartData = null;
  var pendingAddToCartTimer = null;

  function nowIso() {
    return new Date().toISOString();
  }

  function safeJsonParse(text, fallback) {
    try {
      return JSON.parse(text);
    } catch (error) {
      return fallback;
    }
  }

  function getContext() {
    var el = document.getElementById('florss-crm-context');
    if (!el) return {};
    return safeJsonParse(el.textContent || '{}', {});
  }

  var context = getContext();

  function randomId(prefix) {
    return prefix + '_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
  }

  function getStoredId(key, prefix) {
    try {
      var stored = window.localStorage.getItem(STORAGE_PREFIX + key);
      if (stored) return stored;
      var created = randomId(prefix);
      window.localStorage.setItem(STORAGE_PREFIX + key, created);
      return created;
    } catch (error) {
      return randomId(prefix);
    }
  }

  function getSessionId() {
    var key = STORAGE_PREFIX + 'session';
    var tsKey = STORAGE_PREFIX + 'session_ts';
    var timestamp = Date.now();

    try {
      var stored = window.sessionStorage.getItem(key);
      var lastSeen = Number(window.sessionStorage.getItem(tsKey) || 0);
      if (stored && timestamp - lastSeen < SESSION_TTL) {
        window.sessionStorage.setItem(tsKey, String(timestamp));
        return stored;
      }

      var created = randomId('s');
      window.sessionStorage.setItem(key, created);
      window.sessionStorage.setItem(tsKey, String(timestamp));
      return created;
    } catch (error) {
      return randomId('s');
    }
  }

  var visitorId = getStoredId('visitor', 'v');
  var sessionId = getSessionId();

  function getSearchParams() {
    var params = {};
    var allowed = [
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_content',
      'utm_term',
      'gclid',
      'fbclid',
      'ttclid'
    ];

    allowed.forEach(function (key) {
      var value = new URLSearchParams(window.location.search).get(key);
      if (value) params[key] = value;
    });

    return params;
  }

  function readJsonStorage(storage, key, fallback) {
    try {
      return safeJsonParse(storage.getItem(STORAGE_PREFIX + key) || '', fallback);
    } catch (error) {
      return fallback;
    }
  }

  function writeJsonStorage(storage, key, value) {
    try {
      storage.setItem(STORAGE_PREFIX + key, JSON.stringify(value));
    } catch (error) {}
  }

  function removeStorage(storage, key) {
    try {
      storage.removeItem(STORAGE_PREFIX + key);
    } catch (error) {}
  }

  function classifyReferrer(referrer) {
    var ref = String(referrer || '').toLowerCase();
    if (!ref) return 'direct';
    if (ref.indexOf('google.') !== -1) return 'google';
    if (ref.indexOf('instagram.') !== -1) return 'instagram';
    if (ref.indexOf('facebook.') !== -1 || ref.indexOf('fb.') !== -1) return 'facebook';
    if (ref.indexOf('tiktok.') !== -1) return 'tiktok';
    if (ref.indexOf('youtube.') !== -1) return 'youtube';
    if (ref.indexOf('whatsapp') !== -1 || ref.indexOf('wa.me') !== -1) return 'whatsapp';
    if (ref.indexOf('florss.com.br') !== -1 || ref.indexOf('crm.florss.com.br') !== -1) return 'internal';
    return 'referral';
  }

  function hasCampaignParams(params) {
    return Boolean(
      params.utm_source ||
      params.utm_medium ||
      params.utm_campaign ||
      params.gclid ||
      params.fbclid ||
      params.ttclid
    );
  }

  function buildTouch() {
    var params = getSearchParams();
    var referrer = document.referrer || '';
    var refSource = classifyReferrer(referrer);
    var source = params.utm_source || (params.gclid ? 'google' : '') || (params.fbclid ? 'meta' : '') || (params.ttclid ? 'tiktok' : '') || refSource;
    var medium = params.utm_medium || (hasCampaignParams(params) ? 'paid' : (referrer ? 'referral' : 'direct'));

    return {
      source: source,
      medium: medium,
      campaign: params.utm_campaign || '',
      content: params.utm_content || '',
      term: params.utm_term || '',
      gclid: params.gclid || '',
      fbclid: params.fbclid || '',
      ttclid: params.ttclid || '',
      referrer: referrer,
      landing_page: window.location.href,
      landing_path: window.location.pathname,
      captured_at: nowIso()
    };
  }

  function getAttribution() {
    var current = buildTouch();
    var first = readJsonStorage(window.localStorage, 'first_touch', null);
    var last = readJsonStorage(window.localStorage, 'last_touch', null);
    var currentHasSignal = hasCampaignParams(getSearchParams()) || current.source !== 'direct';

    if (!first) {
      first = current;
      writeJsonStorage(window.localStorage, 'first_touch', first);
    }

    if (currentHasSignal || !last) {
      last = current;
      writeJsonStorage(window.localStorage, 'last_touch', last);
    }

    writeJsonStorage(window.sessionStorage, 'session_touch', current);

    return {
      first_touch: first,
      last_touch: last,
      session_touch: current
    };
  }

  function getFunnelStage(eventName) {
    var stages = {
      page_view: 'awareness',
      product_view: 'interest',
      scroll_depth: 'engagement',
      search_submit: 'intent',
      add_to_cart: 'intent',
      cart_update: 'intent',
      cart_view: 'consideration',
      checkout_start: 'checkout',
      whatsapp_click: 'lead'
    };

    return stages[eventName] || 'event';
  }

  function moneyFromCents(cents) {
    return Math.round(Number(cents || 0)) / 100;
  }

  function getDeviceType() {
    var width = window.innerWidth || document.documentElement.clientWidth || 0;
    if (width < 750) return 'mobile';
    if (width < 990) return 'tablet';
    return 'desktop';
  }

  function getCart() {
    if (cachedCart) return Promise.resolve(cachedCart);
    if (cartPromise) return cartPromise;
    if (typeof window.fetch !== 'function') return Promise.resolve(null);

    cartPromise = window.fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart_unavailable');
        return response.json();
      })
      .then(function (cart) {
        cachedCart = cart;
        cartPromise = null;
        return cart;
      })
      .catch(function () {
        cartPromise = null;
        return null;
      });

    return cartPromise;
  }

  function cartSummary(cart) {
    if (!cart) return null;

    return {
      token: cart.token || null,
      item_count: cart.item_count || 0,
      total_price_cents: cart.total_price || 0,
      total_price: moneyFromCents(cart.total_price || 0),
      items: (cart.items || []).slice(0, 10).map(function (item) {
        return {
          product_id: item.product_id || null,
          variant_id: item.variant_id || item.id || null,
          handle: item.handle || null,
          title: item.product_title || item.title || null,
          variant_title: item.variant_title || null,
          quantity: item.quantity || 0,
          price_cents: item.price || 0,
          line_price_cents: item.line_price || 0
        };
      })
    };
  }

  function basePayload(eventName, data) {
    var url = window.location.href;
    var utms = getSearchParams();
    var attribution = getAttribution();
    var lastTouch = attribution.last_touch || {};

    return Object.assign({
      event_id: randomId('evt'),
      event: eventName,
      event_name: eventName,
      source: 'florss_storefront',
      tracking_version: '2026-05-21.1',
      funnel_stage: getFunnelStage(eventName),
      timestamp: nowIso(),
      page_url: url,
      page_path: window.location.pathname,
      page_title: document.title || '',
      referrer: document.referrer || '',
      canonical_url: context.canonical_url || '',
      template: context.template || '',
      template_suffix: context.template_suffix || '',
      page_type: context.page_type || '',
      visitor_id: visitorId,
      session_id: sessionId,
      language: navigator.language || '',
      timezone: (Intl.DateTimeFormat().resolvedOptions() || {}).timeZone || '',
      device_type: getDeviceType(),
      viewport_width: window.innerWidth || 0,
      viewport_height: window.innerHeight || 0,
      screen_width: window.screen ? window.screen.width : 0,
      screen_height: window.screen ? window.screen.height : 0,
      shop: context.shop || null,
      product: context.product || null,
      collection: context.collection || null,
      customer: context.customer || null,
      utm: utms,
      attribution: attribution,
      attribution_source: lastTouch.source || '',
      attribution_medium: lastTouch.medium || '',
      attribution_campaign: lastTouch.campaign || '',
      attribution_content: lastTouch.content || '',
      attribution_term: lastTouch.term || ''
    }, data || {});
  }

  function dedupeKey(eventName, payload) {
    if (eventName === 'add_to_cart') {
      return [
        eventName,
        payload.page_path || '',
        payload.product_variant_id || payload.variant_id || '',
        payload.quantity || ''
      ].join('|');
    }

    return [
      eventName,
      payload.page_path || '',
      payload.product_variant_id || '',
      payload.element_text || '',
      payload.href || '',
      payload.scroll_depth || ''
    ].join('|');
  }

  function shouldSend(eventName, payload, ttl) {
    var key = dedupeKey(eventName, payload);
    var now = Date.now();
    var expiresIn = ttl || 900;

    if (sentKeys[key] && now - sentKeys[key] < expiresIn) return false;
    sentKeys[key] = now;
    return true;
  }

  function pushDataLayer(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  function sendPayload(payload) {
    var body = JSON.stringify(payload);

    pushDataLayer(payload);

    if (navigator.sendBeacon) {
      try {
        // Plain text avoids cross-origin preflight failures in storefront browsers.
        if (navigator.sendBeacon(ENDPOINT, body)) return;
      } catch (error) {}
    }

    if (typeof window.fetch !== 'function') return;

    window.fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: body,
      keepalive: true
    }).catch(function () {});
  }

  function track(eventName, data, options) {
    var payload = basePayload(eventName, data);
    var opts = options || {};

    if (opts.dedupe !== false && !shouldSend(eventName, payload, opts.ttl)) return;

    if (opts.includeCart === false) {
      sendPayload(payload);
      return;
    }

    getCart()
      .then(function (cart) {
        var summary = cartSummary(cart);
        payload.cart = summary;
        if (summary) {
          payload.cart_token = summary.token;
          payload.cart_item_count = summary.item_count;
          payload.cart_total_cents = summary.total_price_cents;
        }
        sendPayload(payload);
      })
      .catch(function () {
        payload.cart = null;
        sendPayload(payload);
      });
  }

  window.FlorssCRM = window.FlorssCRM || {};
  window.FlorssCRM.track = track;

  function getText(el) {
    return ((el && (el.innerText || el.textContent)) || '').replace(/\s+/g, ' ').trim().slice(0, 160);
  }

  function getHref(el) {
    return (el && el.getAttribute && el.getAttribute('href')) || '';
  }

  function getVariantFromForm(form) {
    if (!form) return null;
    var input = form.querySelector('[name="id"], [data-florss-form-variant-id], [data-florss-variant-id-input]');
    return input && input.value ? input.value : null;
  }

  function getQuantityFromForm(form) {
    if (!form) return 1;
    var input = form.querySelector('[name="quantity"], input[type="number"]');
    return Number(input && input.value ? input.value : 1) || 1;
  }

  function isCartAddForm(form) {
    if (!form) return false;
    var action = form.getAttribute('action') || '';
    return action.indexOf('/cart/add') !== -1 || Boolean(form.querySelector('[name="id"]'));
  }

  function isWhatsappElement(el) {
    if (!el) return false;
    var href = getHref(el).toLowerCase();
    return Boolean(
      el.closest('[data-flora-whatsapp-click], .florss-whatsapp-float, .whatsapp-float, .florss-flora-whatsapp-btn') ||
      href.indexOf('wa.me') !== -1 ||
      href.indexOf('whatsapp') !== -1 ||
      href.indexOf('crm.florss.com.br/r/flora') !== -1
    );
  }

  function isCheckoutElement(el) {
    if (!el) return false;
    var href = getHref(el).toLowerCase();
    var text = getText(el).toLowerCase();
    var name = (el.getAttribute('name') || '').toLowerCase();
    var value = (el.getAttribute('value') || '').toLowerCase();

    return href.indexOf('/checkout') !== -1 ||
      name === 'checkout' ||
      value.indexOf('/checkout') !== -1 ||
      text.indexOf('checkout') !== -1 ||
      text.indexOf('finalizar') !== -1 ||
      text.indexOf('comprar agora') !== -1;
  }

  function isAddToCartElement(el) {
    if (!el) return false;
    var text = getText(el).toLowerCase();
    return Boolean(
      el.closest('[data-florss-add-to-cart-submit], [data-florss-add-to-cart], .product-form__submit, .sticky-add') ||
      text.indexOf('adicionar') !== -1 ||
      text.indexOf('quero meu kit') !== -1
    );
  }

  function clearPendingAddToCart() {
    if (pendingAddToCartTimer) {
      window.clearTimeout(pendingAddToCartTimer);
      pendingAddToCartTimer = null;
    }
  }

  function mergeData(base, extra) {
    var merged = {};
    var key;
    base = base || {};
    extra = extra || {};

    for (key in base) {
      if (Object.prototype.hasOwnProperty.call(base, key)) merged[key] = base[key];
    }

    for (key in extra) {
      if (Object.prototype.hasOwnProperty.call(extra, key) && extra[key] !== null && extra[key] !== undefined && extra[key] !== '') {
        merged[key] = extra[key];
      }
    }

    return merged;
  }

  function getPendingAddToCartData() {
    var stored = readJsonStorage(window.sessionStorage, 'pending_add_to_cart', null);
    if (!stored || Date.now() - Number(stored.created_at || 0) > 30000) {
      removeStorage(window.sessionStorage, 'pending_add_to_cart');
      return pendingAddToCartData;
    }

    return mergeData(stored.data, pendingAddToCartData);
  }

  function hasPendingAddToCart() {
    return Boolean(getPendingAddToCartData());
  }

  function queueAddToCartIntent(data) {
    var attribution = getAttribution();
    var lastTouch = attribution.last_touch || {};
    var product = context.product || {};
    var enrichedData = mergeData({
      page_url: window.location.href,
      page_path: window.location.pathname,
      product_id: product.id || null,
      product_handle: product.handle || null,
      product_title: product.title || null,
      product_variant_id: product.variant_id || null,
      utm: getSearchParams(),
      attribution: attribution,
      attribution_source: lastTouch.source || '',
      attribution_medium: lastTouch.medium || '',
      attribution_campaign: lastTouch.campaign || '',
      attribution_content: lastTouch.content || '',
      attribution_term: lastTouch.term || ''
    }, data);

    pendingAddToCartData = mergeData(pendingAddToCartData, enrichedData);
    writeJsonStorage(window.sessionStorage, 'pending_add_to_cart', {
      created_at: Date.now(),
      data: pendingAddToCartData
    });
    clearPendingAddToCart();

    pendingAddToCartTimer = window.setTimeout(function () {
      sendConfirmedAddToCart({ source_action: 'intent_timeout' }, 900);
    }, 1600);
  }

  function sendConfirmedAddToCart(data, delay) {
    var eventData = mergeData(getPendingAddToCartData(), data);
    pendingAddToCartData = null;
    removeStorage(window.sessionStorage, 'pending_add_to_cart');
    clearPendingAddToCart();

    window.setTimeout(function () {
      cachedCart = null;
      track('add_to_cart', eventData, { ttl: 5000 });
    }, delay || 900);
  }

  function consumePendingAddToCartOnCartPage() {
    if (window.location.pathname !== '/cart') return;

    var stored = readJsonStorage(window.sessionStorage, 'pending_add_to_cart', null);
    if (!stored || Date.now() - Number(stored.created_at || 0) > 30000) {
      removeStorage(window.sessionStorage, 'pending_add_to_cart');
      return;
    }

    sendConfirmedAddToCart({ source_action: 'cart_page_confirmed' }, 700);
  }

  function trackCartUpdateOrPendingAdd(sourceAction) {
    cachedCart = null;

    if (hasPendingAddToCart()) {
      sendConfirmedAddToCart({ source_action: sourceAction }, 900);
      return;
    }

    // Theme cart events can fire passively on page load; keep BI clean.
    return;
  }

  document.addEventListener('click', function (event) {
    var target = event.target.closest('a, button, [role="button"]');
    if (!target) return;

    if (isWhatsappElement(target)) {
      track('whatsapp_click', {
        element_text: getText(target),
        href: getHref(target),
        location: target.className || target.dataset || ''
      }, { ttl: 1500 });
      return;
    }

    if (isCheckoutElement(target)) {
      track('checkout_start', {
        element_text: getText(target),
        href: getHref(target)
      }, { ttl: 1500 });
      return;
    }

    if (isAddToCartElement(target)) {
      var form = target.closest('form');
      queueAddToCartIntent({
        element_text: getText(target),
        product_variant_id: getVariantFromForm(form),
        quantity: getQuantityFromForm(form),
        source_action: 'click'
      });
    }
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;

    if (isCartAddForm(form)) {
      queueAddToCartIntent({
        element_text: 'form_submit',
        product_variant_id: getVariantFromForm(form),
        quantity: getQuantityFromForm(form),
        source_action: 'form_submit'
      });
      return;
    }

    var action = (form.getAttribute('action') || '').toLowerCase();
    if (action.indexOf('/search') !== -1) {
      var input = form.querySelector('[name="q"], input[type="search"]');
      track('search_submit', {
        search_term: input && input.value ? input.value : ''
      }, { includeCart: false, ttl: 1500 });
    }
  }, true);

  function patchFetch() {
    if (!window.fetch || window.__florssCrmFetchPatched) return;
    window.__florssCrmFetchPatched = true;

    var originalFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var resource = args[0];
      var url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
      var isAdd = url.indexOf('/cart/add') !== -1;
      var isChange = url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1 || url.indexOf('/cart/clear') !== -1;

      return originalFetch.apply(this, args).then(function (response) {
        if (response && response.ok && (isAdd || isChange)) {
          cachedCart = null;
          window.setTimeout(function () {
            if (isAdd || hasPendingAddToCart()) {
              sendConfirmedAddToCart({ source_action: 'ajax_cart_add' }, 900);
              return;
            }

            track('cart_update', {
              source_action: 'ajax_cart_update'
            }, { ttl: 3000 });
          }, 500);
        }
        return response;
      });
    };
  }

  function trackScrollDepth() {
    var scrollTop = window.scrollY || document.documentElement.scrollTop || 0;
    var doc = document.documentElement;
    var scrollable = Math.max(1, doc.scrollHeight - window.innerHeight);
    var depth = Math.round((scrollTop / scrollable) * 100);

    scrollDepths.forEach(function (target) {
      if (depth >= target && !sentScrollDepths[target]) {
        sentScrollDepths[target] = true;
        track('scroll_depth', { scroll_depth: target }, { includeCart: false, ttl: 60000 });
      }
    });
  }

  function bindCartEvents() {
    document.addEventListener('cart:updated', function () {
      trackCartUpdateOrPendingAdd('cart_updated_event');
    });

    document.addEventListener('florss:cart-updated', function () {
      trackCartUpdateOrPendingAdd('florss_cart_updated_event');
    });
  }

  function init() {
    patchFetch();
    bindCartEvents();

    track('page_view', {}, { includeCart: false, ttl: 10000 });

    if (context.product && context.product.handle) {
      track('product_view', {
        product_id: context.product.id,
        product_handle: context.product.handle,
        product_title: context.product.title,
        product_variant_id: context.product.variant_id
      }, { includeCart: false, ttl: 10000 });
    }

    if (window.location.pathname === '/cart') {
      track('cart_view', {}, { includeCart: false, ttl: 10000 });
      consumePendingAddToCartOnCartPage();
    }

    window.addEventListener('scroll', function () {
      window.requestAnimationFrame(trackScrollDepth);
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
